const actionDict = {
  50: 'Подключено',
  51: 'Отключено',
};

export const action = (val) => actionDict[val];
